import { AxiosError, AxiosResponse } from 'axios'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import {
  startLoading,
  stopLoading,
} from '../../../common/modules/loading/actions'
import { LoadingTypes } from '../../../common/modules/loading/reducer'
import { getErrorMessages } from '../../../common/utils/error'
import { RequestFailureMessage } from '../../../common/utils/messagesContants'
import { AppDispatch, RootState } from '../../../store'
import { errorLogger } from '../../../common/utils/errorLogger'
import { camelize } from 'casing'
import { fetchWorkload } from '../../api/cloudfaas'
import { WorkloadState } from './reducer'

export enum WorkloadActionTypes {
  SET_WORKLOAD = 'SET_WORKLOAD',
  CLEAR_WORKLOAD = 'CLEAR_WORKLOAD',
  SET_SELECTED_WORKLOAD = 'SET_SELECTED_WORKLOAD',
  CLEAR_SELECTED_WORKLOAD = 'CLEAR_SELECTED_WORKLOAD',
  SET_ERROR = 'SET_ERROR',
  SET_INTIAL_PAGE = 'SET_INITIAL_PAGE',
  CLEAR_INITIAL_PAGE = 'CLEAR_INITAL_PAGE',
}

export const getWorkloadList =
  (
    partnerId: string,
    hostedRegion?: string,
    workloadName?: string,
    reviewOwner?: string,
    pageNumber: number = 1,
    rowsPerSize: number = 10
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.CLOUDFAAS_WORKLOAD_LIST))
    try {
      const response = await fetchWorkload(
        partnerId,
        hostedRegion,
        workloadName,
        reviewOwner,
        rowsPerSize,
        pageNumber
      )

      if (response?.data) {
        const workloadData = camelize(response.data)
        const workloadState: WorkloadState = {
          workload: workloadData.wafrAssessments,
          pageNumber: workloadData.pageNumber || pageNumber,
          rowsPerSize: workloadData.rowsPerSize || rowsPerSize,
          totalNumberOfPages: workloadData.totalNumberOfPages || 1,
          totalWorkloadsCount: workloadData.totalWafrAssessmentsCount,
          hasMore:
            (workloadData.pageNumber || pageNumber) <
            (workloadData.totalNumberOfPages || 1),
          links: workloadData.links || {},
        }
        dispatch(setWorkload(workloadState))
      }
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.CLOUDFAAS_WORKLOAD_LIST))
    }
  }

export const setWorkload = (workload: WorkloadState) => ({
  type: WorkloadActionTypes.SET_WORKLOAD,
  payload: workload,
})

export const setPage = () => ({
  type: WorkloadActionTypes.SET_INTIAL_PAGE,
})

export const clearPage = () => ({
  type: WorkloadActionTypes.CLEAR_INITIAL_PAGE,
})
